import { render, staticRenderFns } from "./PayoutPlan.vue?vue&type=template&id=2ae95f1b&"
import script from "./PayoutPlan.vue?vue&type=script&lang=js&"
export * from "./PayoutPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports